module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_proposal-restaurant-b13849e4c0b2cbd2541523e27dff4b03.png";